import {cameraSnapshot,applyCameraState} from '../lib/camera-state.js';
// Strumenti shell v2: viste salvate (semantica v1: stato completo con nome),
// reset vista, crediti fonti, onboarding una-tantum.
const VIEWS_KEY = 'wsv2-saved-views';

function collectState(map) {
    const c = map.getCenter();
    const layers = {};
    document.querySelectorAll('.wsv2-toggle input[id]').forEach(i => { if (i.checked) layers[i.id] = 1; });
    return {
        lat: +c.lat.toFixed(5), lon: +c.lng.toFixed(5), zoom: +map.getZoom().toFixed(2),
        parametro: document.getElementById('selectParametro')?.value,
        layers,
        camera:cameraSnapshot(map),
        savedAt: new Date().toISOString(),
    };
}

function applyState(map, st) {
    if(st.camera)applyCameraState(map,st.camera,{animate:false});
    if (st.lat != null && st.lon != null) map.jumpTo({ center: [st.lon, st.lat], zoom: st.zoom ?? map.getZoom() });
    const sel = document.getElementById('selectParametro');
    if (st.parametro && sel && sel.value !== st.parametro) { sel.value = st.parametro; sel.dispatchEvent(new Event('change')); }
    document.querySelectorAll('.wsv2-toggle input[id]').forEach(i => {
        const want = !!st.layers?.[i.id];
        // Solo i layer dati (ovl-/chk*): non toccare i toggle di visualizzazione se assenti dallo stato.
        if (i.checked !== want && (i.id.startsWith('ovl-') || ['chkRadar', 'chkSatellite', 'chkLightning', 'chkTemporali'].includes(i.id))) {
            i.checked = want;
            i.dispatchEvent(new Event('change'));
        }
    });
}

function loadViews() { try { return JSON.parse(localStorage.getItem(VIEWS_KEY) || '[]'); } catch (e) { return []; } }
function saveViews(v) { try { localStorage.setItem(VIEWS_KEY, JSON.stringify(v)); } catch (e) {} }

export function buildToolsGroup(map, groupFactory, toggleRowFactory, body) {
    const g = groupFactory('⭐ Viste salvate', 'views', false);
    const gb = g.querySelector('.wsv2-group__body');
    const wrap = document.createElement('div');
    wrap.className = 'wsv2-views';
    gb.appendChild(wrap);

    function renderList() {
        const views = loadViews();
        wrap.innerHTML = `
            <div class="wsv2-views-add">
                <input type="text" placeholder="Nome vista…" maxlength="40">
                <button>Salva</button>
            </div>
            ${views.map((v, i) => `
                <div class="wsv2-views-item" data-i="${i}">
                    <span>${v.name}</span>
                    <button data-apply title="Applica">↩</button>
                    <button data-del title="Elimina">🗑</button>
                </div>`).join('') || '<div class="wsv2-coming">Nessuna vista salvata.</div>'}
            <div class="wsv2-views-actions"><button data-reset title="Riporta la mappa alle impostazioni iniziali e cancella le tue preferenze salvate">♻️ Ripristina tutto</button></div>
            <div class="wsv2-views-hint">Riporta la mappa com'era all'inizio: cancella viste salvate, layer attivi, tema e preferenze di questa mappa.</div>`;
        wrap.querySelector('.wsv2-views-add button').addEventListener('click', () => {
            const name = wrap.querySelector('input').value.trim() || `Vista ${views.length + 1}`;
            views.push({ name, state: collectState(map) });
            saveViews(views);
            renderList();
        });
        wrap.querySelectorAll('.wsv2-views-item').forEach(item => {
            const i = Number(item.dataset.i);
            item.querySelector('[data-apply]').addEventListener('click', () => applyState(map, views[i].state));
            item.querySelector('[data-del]').addEventListener('click', () => { views.splice(i, 1); saveViews(views); renderList(); });
        });
        wrap.querySelector('[data-reset]').addEventListener('click', () => {
            const ok = window.confirm(
                'Ripristinare la mappa alle impostazioni iniziali?\n\n' +
                'Vengono cancellate le TUE preferenze salvate su questa mappa: ' +
                'viste salvate, layer attivi, parametro, tema e lingua. ' +
                'La mappa torna alla configurazione di partenza.');
            if (!ok) return;
            // Prima il reset "cosmetico" era incompleto (mancava wsv2-state, la
            // vera memoria dei toggle → i layer riapparivano). Ora azzero TUTTE le
            // chiavi di questa mappa: qualunque 'wsv2-*' + le preferenze condivise
            // con la v1 (tema/lingua) e i flag minori.
            try {
                const shared = new Set(['ws-theme', 'ws-lang', 'wsSolarMode']);
                const toDrop = [];
                for (let i = 0; i < localStorage.length; i++) {
                    const k = localStorage.key(i);
                    if (k && (k.startsWith('wsv2-') || shared.has(k))) toDrop.push(k);
                }
                toDrop.forEach(k => localStorage.removeItem(k));
            } catch (e) {}
            window.location.href = window.location.pathname; // URL pulito: droppa anche i deep-link
        });
    }
    renderList();
    body.appendChild(g);
}

export function initCredits() {
    const bar = document.querySelector('.wsv2-topbar');
    const anchor = document.getElementById('btnTheme');
    const b = document.createElement('button');
    b.className = 'wsv2-iconbtn';
    b.id = 'btnCredits';
    b.title = 'Fonti dati';
    b.textContent = 'ⓘ';
    bar.insertBefore(b, anchor);
    b.addEventListener('click', () => {
        let pop = document.querySelector('.wsv2-credits');
        if (pop) { pop.remove(); return; }
        pop = document.createElement('div');
        pop.className = 'wsv2-panel wsv2-credits';
        pop.innerHTML = `
            <strong>Fonti dati</strong>
            <p>Stazioni: SIAS, DRPC Sicilia, Weather Sicily, MeteoSicilia, CMS, CISAR Agrigento, METAR, ISPRA;
            pluviometri <a href="https://idrologia.unipa.it/it/data" target="_blank" rel="noopener noreferrer">HYCLIC · Università degli Studi di Palermo</a> (misure non validate dalla fonte).
            Radar: Radar-DPC Protezione Civile e <a href="https://idrologia.unipa.it/it/radar" target="_blank" rel="noopener noreferrer">HYCLIC · Università degli Studi di Palermo</a> quando aggiornato.
            Satellite e fulmini: EUMETSAT (MTG), Blitzortung.
            Mare: Copernicus Marine (CMEMS), EMODnet, NOAA NDBC. Satelliti ambiente: NASA GIBS,
            LSA SAF, DLR, EFFIS/Copernicus EMS. Basi mappa: © OpenStreetMap, © Esri.</p>
            <button data-close>Chiudi</button>`;
        document.body.appendChild(pop);
        pop.querySelector('[data-close]').addEventListener('click', () => pop.remove());
    });
}
